import moment from 'moment';

export const CREDENTIALS_INVALID = 'credentials_invalid';
export const INVITATION_NOT_FOUND = 'invitation_not_found';
export const INVITATION_SSO_ENABLED = 'invitation_sso_enabled';
export const INVITE_CODE_EXPIRED = 'invite_code_expired';
export const INVITE_CODE_USED = 'invite_code_used';
export const LOCK_OUT = 'lock_out';
export const SSO_ENABLED = 'sso_enabled';

const knownErrors = [
  CREDENTIALS_INVALID, 
  INVITATION_NOT_FOUND,
  INVITATION_SSO_ENABLED,
  INVITE_CODE_EXPIRED,
  INVITE_CODE_USED,
  LOCK_OUT, 
  SSO_ENABLED
];

export const isKnownError = (type) => knownErrors.includes(type);

export const formatErrorPlaceholders = (error) => {
  if (error?.error_type === LOCK_OUT && error?.error_args?.lockout_until) {
    return { duration: moment.utc(error.error_args.lockout_until).fromNow(true) };
  }
};
